import React, { useEffect, useState, useRef } from "react";
import { certifications } from "../config/config";

const Certifications = () => {
  const [visibleIndexes, setVisibleIndexes] = useState([]);
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.dataset.index);
          if (entry.isIntersecting && !visibleIndexes.includes(index)) {
            setVisibleIndexes((prev) => [...prev, index]);
          }
        });
      },
      { threshold: 0.1 }
    );

    refs.current.forEach((ref) => ref && observer.observe(ref));

    return () => {
      refs.current.forEach((ref) => ref && observer.unobserve(ref));
    };
  }, [visibleIndexes]);

  return (
    <div className="p-8 rounded-lg text-center">
      <h2 className="text-xl sm:text-2xl font-bold mb-6 text-white">
        Certifications
      </h2>
      <div className="flex flex-wrap justify-center gap-4">
        {certifications.map((cert, index) => (
          <a
            key={index}
            href={cert.url}
            target="_blank"
            rel="noopener noreferrer"
            data-index={index}
            ref={(el) => (refs.current[index] = el)}
            className={`${
              visibleIndexes.includes(index)
                ? "translate-x-0 opacity-100 ease-out-cubic"
                : "-translate-x-full opacity-0"
            } bg-white/5 hover:bg-white/10 border border-white/5 text-white px-6 py-4 rounded-[2rem] shadow-lg flex items-center space-x-4 transform transition-all duration-500 w-full sm:w-auto`}
          >
            <span className="text-base sm:text-lg">{cert.icon}</span>
            <span className="font-medium text-sm sm:text-base md:text-lg">
              {cert.title}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Certifications;
